import Vue from 'vue';
import Vuex from 'vuex';
import Trip from 'app/shared/models/trip.model';
import SearchBody from './app/shared/models/search-body.model';
import MoreOptions, { TripSegments } from 'app/shared/models/trip-segments.model';
import SearchResults from './app/shared/models/search-results.model';
import AffiliateViewDataModel from './app/shared/models/affiliate-view-data.model';
import Solutions from './app/shared/models/solutions.model';
import createPersistedState from 'vuex-persistedstate';
import {Currencies} from "./app/shared/common/currencies";
import {IndieLogin} from "./app/services/indie-login";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    search: new SearchBody(),
    trips: Array<Trip>(),
    isNeedToStartSearch: false,
    selectedSegments: Array<TripSegments>(),
    search_results: new SearchResults(),
    more_options: Array<MoreOptions>(),
    solutions: new Solutions(),
    totalCost: 0,
    isFromSavedTrips: false,
    currency: {code: '', sign: '', rate: 0},
    currencies: Currencies,
    itineraryId: 0,
    resultId: 0,
    indieLogin: null,
    should_show_change_panel: false,
    should_select_first_option_for_all_legs: false,
    showFnfNotice: false,
    creditUrlParam: "",
    creditData: null,
    selectedAirlineCreditOptions: Array<any>(),
    selectedAirlineCreditData: Array<any>(),
    usedCreditByAirline: Array<any>(),
    affiliateViewData: new AffiliateViewDataModel()
  },
  mutations: {
    saveSearch(state, search) {
      state.search = search;
    },
    saveTrips(state, trips) {
      state.trips = trips;
    },
    startSearch(state) {
      state.isNeedToStartSearch = true;
    },
    stopSearch(state) {
      state.isNeedToStartSearch = false;
    },
    selectSegments(state, selectedSegments) {
      state.selectedSegments = selectedSegments;
    },
    cleanSegments(state) {
      state.selectedSegments = [];
    },
    saveSearchResults(state, search_results) {
      state.search_results.results = search_results;
    },
    saveMoreOptions(state, more_options) {
      state.more_options = more_options;
    },
    saveSolutions(state, solutions){
      state.solutions = solutions;
    },
    totalCost(state, cost){
      state.totalCost = cost;
    },
    fromSavedTrips(state){
      state.isFromSavedTrips = true;
    },
    disableFromSavedTrips(state){
      state.isFromSavedTrips = false;
    },
    currency(state, currency){
      state.currency = currency;
    },
    itineraryId(state, itinerary_id){
      state.itineraryId = itinerary_id;
    },
    resultId(state, result_id){
      state.resultId = result_id;
    },
    setIndieLogin(state, indieLogin: IndieLogin){
      // @ts-ignore
      state.indieLogin = indieLogin;
    },
    setFlagShowChangeFlightsPanel(state, shouldShow: boolean){

    },
    setShouldSelectFirstOptionForAllLegs(state, shouldAutoSelect: boolean){
      state.should_select_first_option_for_all_legs = shouldAutoSelect;
    },
    setShowFnfNotice(state, shouldShow: boolean){
      state.showFnfNotice = shouldShow;
    },
    setCreditUrlParam(state, creditUrlParam: string){
      state.creditUrlParam = creditUrlParam;
    },
    setCreditData(state, creditData: any){
      state.creditData = creditData;
    },
    setSelectedAirlineCreditOptions(state, airlineCreditOptions: any[]){
      state.selectedAirlineCreditOptions = airlineCreditOptions;
    },
    setSelectedAirlineCreditData(state, airlineCreditData: any){
      state.selectedAirlineCreditData = airlineCreditData;
    },
    setUsedCreditByAirline(state, usedCreditByAirline: any){
      state.usedCreditByAirline = usedCreditByAirline;
    },
    setAffiliateViewData(state, affiliateViewData: any){
      state.affiliateViewData = affiliateViewData;
    }
  },
  actions: {
    setLoginNeeded({commit, state}, loginNeeded: boolean){
      if(state && state.indieLogin && loginNeeded === true){
        // @ts-ignore
        if(!state.indieLogin.isLoginPopup){
          // @ts-ignore
          state.indieLogin.openLoginPopup();
        }
      }
    },
    async initIndieLogin({commit}){
      await commit("setIndieLogin", new IndieLogin());
    },
    activateChangeFlightsPanel({commit, state}){
      commit("setFlagShowChangeFlightsPanel", true);
    },
    clearFlagForChangeFlightsPanel({commit, state}){
      commit("setFlagShowChangeFlightsPanel", false);
    },
    autoSelectFirstOptionForAllLegs({commit, state}){
      commit("setShouldSelectFirstOptionForAllLegs", true);
    },
    clearSelectFirstOptionForAllLegs({commit, state}){
      commit("setShouldSelectFirstOptionForAllLegs", false);
    },
    enableFnfNotice({commit, state}){
      commit("setShowFnfNotice", true);
    },
    disableFnfNotice({commit, state}){
      commit("setShowFnfNotice", false);
    },
    storeCreditUrlParam({commit, state}, creditUrlParam: string){
      commit('setCreditUrlParam', creditUrlParam);
    },
    storeCreditData({commit, state}, creditData: any){
      commit("setCreditData", creditData)
    },
    storeSelectedAirlineCreditOptions({commit, state}, airlineCreditOptions: any){
      commit("setSelectedAirlineCreditOptions", airlineCreditOptions);
    },
    storeSelectedAirlineCreditData({commit, state}, selectedAirlineCreditData: any){
      commit("setSelectedAirlineCreditData", selectedAirlineCreditData);
    },
    storeUsedCreditByAirline({commit, state}, usedCreditByAirline: any){
      console.log("committing used credit by airline");
      console.log(usedCreditByAirline);
      commit("setUsedCreditByAirline", usedCreditByAirline);
    },
    storeAffiliateViewData({commit, state}, affiliateViewData: any){
      commit("setAffiliateViewData", affiliateViewData);
    }
  },
  getters: {
    selectedAirlines: state => {
      // @ts-ignore
      if (state.creditData !== null && state.creditData.credit_lnk_data !== null) {
        // @ts-ignore
        return state.creditData.credit_lnk_data.selected_airlines
            .split(',')
            .map((a:string) => String.prototype.trim.apply(a));
      }
      return [];
    },
    creditAvailable: (state, getters) => {
      let credit = 0;
      // @ts-ignore
      if (state.creditData.credit_data !== null) {
        // @ts-ignore
        let creditData = state.creditData.credit_data;
        if(creditData.airtreks_credit){
          credit += 1*creditData.airtreks_credit;
        }
        if(creditData.passengers_credit){
          for(let i in creditData.passengers_credit){
            for(let code in creditData.passengers_credit[i].airline_credit){
              // @ts-ignore
              if(-1 !== getters.selectedAirlines.indexOf(code)){
                credit += 1*creditData.passengers_credit[i].airline_credit[code].total_amount;
              }
            }
          }
        }
      }
      return credit;
    }
  },
  plugins: [
    createPersistedState({
        storage: window.sessionStorage
    })
  ]
});
